module.exports = __webpack_public_path__ + "img/coach-action-banner.6a443d06.png";